// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2ba5098b","732":"1aae6e6d","977":"93585d55"}[chunkId] + ".chunk.js";
};